// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.load-data-container {
  margin: 20px 30px;
}
.load-data-container .load-data-errors-wrapper {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(158, 158, 158, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
}
.load-data-container .load-data-errors-wrapper .load-data-errors-container {
  background-color: #FFFFFF;
  padding: 20px;
  border-radius: 10px;
  width: 50vw;
}
.load-data-container .load-data-errors-wrapper .load-data-errors-container .load-data-errors-title {
  font-size: 20px;
  font-weight: bold;
}
.load-data-container .load-data-errors-wrapper .load-data-errors-container .load-data-errors-box {
  overflow-y: auto;
  min-height: 100px;
  max-height: 50vh;
}
.load-data-container .load-data-errors-wrapper .load-data-errors-container .load-data-errors-box .load-data-errors-error-row {
  line-height: 30px;
}
.load-data-container .load-data-errors-wrapper .load-data-errors-container .load-data-errors-footer {
  display: flex;
  justify-content: flex-end;
  column-gap: 20px;
}
.load-data-container .load-data-top-button {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 20px;
  column-gap: 20px;
}
.load-data-container .load-data-title {
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.load-data-container .load-data-settings-table {
  margin: 20px 0;
  display: grid;
  grid-template-columns: 200px 1fr;
  row-gap: 20px;
}
.load-data-container .load-data-file-input {
  font-size: 18px;
  color: #6A8991;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}
.load-data-container .load-data-matching-table {
  margin: 20px 0;
  display: grid;
  grid-template-columns: 400px 400px 1fr;
  align-items: center;
  border-left: 1px solid #cbcbcb;
  overflow: auto;
  height: calc(100vh - 460px);
}
.load-data-container .load-data-matching-table .load-data-matching-table-header {
  border-top: 1px solid #cbcbcb;
  font-weight: bold;
  background-color: aliceblue;
}
.load-data-container .load-data-matching-table > div {
  border-right: 1px solid #cbcbcb;
  border-bottom: 1px solid #cbcbcb;
  display: flex;
  height: 53px;
  align-items: center;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings/DBSnapshots/LoadData/LoadData.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;AACD;AACC;EACC,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACC,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACH;AACG;EACC,eAAA;EACA,iBAAA;AACJ;AAEG;EACC,gBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;AAEI;EACC,iBAAA;AAAL;AAIG;EACC,aAAA;EACA,yBAAA;EACA,gBAAA;AAFJ;AAOC;EACC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;AALF;AAQC;EACC,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AANF;AASC;EACC,cAAA;EACA,aAAA;EACA,gCAAA;EACA,aAAA;AAPF;AAUC;EACC,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AARF;AAWC;EACC,cAAA;EACA,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;EACA,2BAAA;AATF;AAWE;EACC,6BAAA;EACA,iBAAA;EACA,2BAAA;AATH;AAaC;EACC,+BAAA;EACA,gCAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAXF","sourcesContent":[".load-data-container {\n\tmargin: 20px 30px;\n\n\t.load-data-errors-wrapper {\n\t\tposition: fixed;\n\t\tz-index: 9999;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tbackground-color: #9e9e9e99;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\t.load-data-errors-container {\n\t\t\tbackground-color: #FFFFFF;\n\t\t\tpadding: 20px;\n\t\t\tborder-radius: 10px;\n\t\t\twidth: 50vw;\n\n\t\t\t.load-data-errors-title {\n\t\t\t\tfont-size: 20px;\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\n\t\t\t.load-data-errors-box {\n\t\t\t\toverflow-y: auto;\n\t\t\t\tmin-height: 100px;\n\t\t\t\tmax-height: 50vh;\n\n\t\t\t\t.load-data-errors-error-row {\n\t\t\t\t\tline-height: 30px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.load-data-errors-footer {\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: flex-end;\n\t\t\t\tcolumn-gap: 20px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.load-data-top-button {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t\tmargin: 20px;\n\t\tcolumn-gap: 20px;\n\t}\n\n\t.load-data-title {\n\t\tfont-size: 20px;\n\t\tfont-weight: bold;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tcolumn-gap: 20px;\n\t}\n\n\t.load-data-settings-table {\n\t\tmargin: 20px 0;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 200px 1fr;\n\t\trow-gap: 20px;\n\t}\n\n\t.load-data-file-input {\n\t\tfont-size: 18px;\n\t\tcolor: #6A8991;\n\t\tcursor: pointer;\n\t\twhite-space: nowrap;\n\t\tuser-select: none;\n\t}\n\n\t.load-data-matching-table {\n\t\tmargin: 20px 0;\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 400px 400px 1fr;\n\t\talign-items: center;\n\t\tborder-left: 1px solid #cbcbcb;\n\t\toverflow: auto;\n\t\theight: calc(100vh - 460px);\n\n\t\t.load-data-matching-table-header {\n\t\t\tborder-top: 1px solid #cbcbcb;\n\t\t\tfont-weight: bold;\n\t\t\tbackground-color: aliceblue;\n\t\t}\n\t}\n\n\t.load-data-matching-table > div {\n\t\tborder-right: 1px solid #cbcbcb;\n\t\tborder-bottom: 1px solid #cbcbcb;\n\t\tdisplay: flex;\n\t\theight: 53px;\n\t\talign-items: center;\n\t\tpadding: 10px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
